import { Box, IconButton, InputAdornment, SvgIcon, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@material-ui/core'
import { useState } from 'react'
import LoadingCard from './LoadingCard'
import { Search as SearchIcon } from 'react-feather'

const applyFilters = (resourceList, query, properties = ['name']) => {
  return resourceList.filter((resource) => {
    let matches = true

    if (query) {
      let containsQuery = false

      properties.forEach((property) => {
        if (resource[property]?.toLowerCase()?.includes(query.toLowerCase())) {
          containsQuery = true
        }
      })

      if (!containsQuery) {
        matches = false
      }
    }

    return matches
  })
}

const applyPagination = (resourceList, page, limit) => {
  return resourceList.slice(page * limit, page * limit + limit)
}

const DefaultSearch = ({ onChange, query, resourceList }) => {
  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SvgIcon fontSize='small' color='action'>
              <SearchIcon />
            </SvgIcon>
          </InputAdornment>
        )
      }}
      onChange={onChange}
      placeholder='Cerca per nome...'
      value={query}
      variant='outlined'
      size='small'
      fullWidth
      disabled={resourceList[0] === '-' || (resourceList.length === 0 && query === '')}
    />
  )
}

const ResourceList = ({ list = [], fields = [], filterBy = ['name'], emptyMessage = 'Nessuna risorsa trovata.', actions = [], customSearch: CustomSearch = null, customHeader: CustomHeader = null }) => {
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(5)
  const [query, setQuery] = useState('')

  const handlePageChange = (event, newPage) => {
    setPage(newPage)
  }

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value))
  }

  const handleQueryChange = (event) => {
    event.persist()
    if (page > 0) {
      setPage(0)
    }

    setQuery(event.target.value)
  }

  const filteredResourceList = CustomSearch ? list : applyFilters(list, query, filterBy)
  const paginatedResourceList = applyPagination(filteredResourceList, page, limit)

  return (
    <Box>
      <Box style={{ marginTop: 16, marginLeft: 16, marginRight: 16 }}>
        {CustomHeader ? <CustomHeader /> : null}
      </Box>
      <Box style={{ marginTop: 16, marginLeft: 16, marginRight: 16 }}>
        {CustomSearch ? <CustomSearch query={query} handleQueryChange={handleQueryChange} /> : <DefaultSearch query={query} onChange={handleQueryChange} resourceList={paginatedResourceList} />}
      </Box>
      <Table size='small'>
        <TableHead>
          <TableRow>
            {fields?.length === 0 && <TableCell style={{ minWidth: 210 }}>Nome</TableCell>}
            {fields?.length > 0 && fields.map(field => <TableCell key={`header-${field.value}`} style={{ minWidth: 210 }}>{field.label}</TableCell>)}
            <TableCell align='right' style={{ minWidth: 140 }}>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedResourceList?.[0] === '-'
            ? (
              <TableRow>
                <TableCell colSpan={5} align='center'>
                  <LoadingCard />
                </TableCell>
              </TableRow>
              )
            : paginatedResourceList?.length === 0
              ? (
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography style={{ marginTop: 12, marginBottom: 12 }} color='textPrimary' variant='body2' align='center'>{emptyMessage}</Typography>
                  </TableCell>
                </TableRow>
                )
              : paginatedResourceList?.map((resource, resourceIndex) => {
                return (
                  <TableRow key={resourceIndex}>
                    {fields?.legth === 0 && (
                      <TableCell>
                        <Typography variant='body1' color='textPrimary'>{resource.name || resource.fullName}</Typography>
                      </TableCell>
                    )}
                    {fields?.length > 0 && fields.map(field => (
                      <TableCell key={`${field.value}-${resourceIndex}`}>
                        <Typography variant='body1' color='textPrimary'>{resource[field.value] ?? '-'}</Typography>
                      </TableCell>
                    )
                    )}
                    <TableCell align='right'>
                      {actions.map(action => (
                        <Tooltip key={action.title} title={action.title || 'Azione'} aria-label={action.title || 'Azione'}>
                          <span>
                            <IconButton onClick={() => action.action(resource) || null}>
                              <SvgIcon fontSize='small'>
                                {action.icon}
                              </SvgIcon>
                            </IconButton>
                          </span>
                        </Tooltip>
                      ))}
                    </TableCell>
                  </TableRow>
                )
              })}
        </TableBody>
      </Table>
      {list.length > limit
        ? (
          <TablePagination
            component='div'
            count={list.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
          )
        : null}
    </Box>
  )
}

export default ResourceList
